/// <amd-module name="VSS/Redux/Modules/ContentViewObserver/ContentViewObserverSelectors" />
import * as Reselect from "Reselect";
import { IFilterState } from "VSSUI/Utilities/Filter";
import { IContentViewAwareState, IFilterDetails } from "./ContentViewObserverContracts";

/** Determine if the filter is active */
export const isFilterActive = Reselect.createSelector(
    [isFilterVisible, getCurrentFilterState],
    (filterVisible: boolean, filterState: IFilterState | undefined): boolean => {
        let isActive = false;
        if (filterState && filterVisible) {
            for (const key in filterState) {
                const filterItemState = filterState[key];
                if (filterItemState && filterItemState.value && filterItemState.value.length) {
                    isActive = true;
                    break;
                }
            }
        }

        return isActive;
    }
);

export function getFilterDetails(state: IContentViewAwareState): IFilterDetails | undefined {
    return state && state.contentViewObserver && state.contentViewObserver.filterDetails;
}

export function isFilterVisible(state: IContentViewAwareState): boolean {
    return (state && state.contentViewObserver.filterDetails && state.contentViewObserver.filterDetails.filterVisible) || false;
}

export function getCurrentFilterState(state: IContentViewAwareState): IFilterState | undefined {
    if (state && state.contentViewObserver && state.contentViewObserver.filterDetails) {
        return state.contentViewObserver.filterDetails.filterState;
    }
}

export function getCurrentPivot(state: IContentViewAwareState): string | undefined {
    if (state && state.contentViewObserver) {
        return state.contentViewObserver.selectedPivot;
    }
}
